import api from '@/api';

import { TaxRegime } from './TaxRegime.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/tax-regime`;

export async function listTaxRegimes(): Promise<TaxRegime[]> {
  const result = (await api.get(`${CONTROLLER_URL}`, null)) as unknown;

  return result as TaxRegime[];
}
